/* eslint-disable import/no-anonymous-default-export */
import { SET_SCROLL_SPEED } from '../actionConstants';

export default (state = 50, action) => {
  switch (action.type) {
    case SET_SCROLL_SPEED:
      return action.payload;
    default:
      return state;
  }
};
